import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    waitForOnboarding:
      'Please wait for the account holder to complete the onboarding',
  },
  fr: {
    waitForOnboarding:
      'Veuillez attendre que le titulaire du compte termine l’inscription',
  },
} as const);

export default locales;
